export enum Path {
  Home = '',

  // Public
  NotFound = '404',
  Static = 'static',
  PrivacyPolicy = 'privacy-policy',
  CopyrightPolicy = 'copyright-policy',
  EWalletTermsConditions = 'e-wallet-terms-conditions',
  UserTermsConditions = 'user-terms-conditions',
  FilmMakerTermsConditions = 'filmmaker-terms-conditions',
  ContactUs = 'contact-us',
  AboutUs = 'about-us',
  FILM_MAKER_DETAIL = 'filmmaker-detail',
  PUBLISHED_FILM_LIST = 'published-movies',
  CookiesPolicy = 'cookies-policy',
  PaymentRefundPolicy = 'payment-refund-policy',
  MovieUploadSuccess = 'film-upload-status',
  I_AM_FILM_MAKER = 'i-am-filmmaker',
  SEARCH = 'search',
  BLANK = 'blank',
  FILM_CONTEST_TERMS = 'film-contest-terms-conditions',
  TELEGU_FILM_CONTEST = 'big-shorts-challenge-terms-conditions',
  MALAYALAM_FILM_CONTEST = 'big-shorts-challenge-malayalam',
  TAMIL_FILM_CONTEST = 'big-shorts-challenge',
  FILMS_BY_GENRE = 'films-by-genre',
  FILMS_BY_LANGUAGE = 'films-by-language',
  ContestRegistration = 'film-maker/contest-registration',

  // Auth
  SignIn = 'sign-in',
  SignUp = 'sign-up',
  SignInRole = 'sign-in-role',
  EmailVerify = 'email-verify',
  FilmMakerSignUp = 'film-maker/sign-up',
  Filmmaker = 'filmmaker',
  CreatePassword = 'create-password',
  SetPassword = 'set-password', // will append /app/set-password
  ForgotPassword = 'forgot-password',
  UpdatePassword = 'update-password',

  // App base url
  App = 'app',

  // Features
  Profile = 'profile',
  Dashboard = 'dashboard',
  CREATE_FILM = 'create-film',
  FILMLIST = 'film-list',
  VIDEO_PLAYER = 'video-player',
  MOVIE_DETAIL = 'movie-detail',
  EDIT_FILM = 'edit-film',
  AllFilm = 'View-film-list',
  PAYMENT_SUCCESS = 'payment/success',
  WILD_CARD_ROUTE = '**',

  //Profile
  VIEWER = 'viewer',
  SUCCESS = 'success',
  RETURN = 'return',

  // QR Code
  QR_CODE = 'qr-code/:qrCodeId',

  // Film list path
  FILM_LIST = 'view-film-list',
  RECENT = 'recent',
  RECOMMENDED = 'recommended',
  FILM_CONTEST = 'film-contest',
  MOST_WATCHED = 'most-watched',
  GENRE = 'genre',
  LANGUAGE = 'language',
  FREE_MOVIES = 'free-movies',
  CONTINUE_WATCHING = 'continue-watching',
  WEB_SERIES = 'web-series',
  MICRO_SERIES = 'micro-series',
  COMING_SOON = 'coming-soon',
  CAREERS = 'careers',
}
